//common
import './common';

document.querySelector('._fairytale-heroes [href="' + window.location.pathname + '"')?.closest('.text-center')?.remove();